module.exports = __webpack_public_path__ + "static/media/30-12.aa130bf6.mp3";